import { gql } from "@apollo/client";

export const GET_ASSIGNMENT_PTO_POLICY = gql`
  query GetAssignmentPtoPolicy($assignmentToken: ID) {
    assignment(id: $assignmentToken) {
      job {
        name
      }
      ptoPolicy: pto_policy {
        name
        eligibilityPeriod: eligibility_period
        rules {
          code
          accrualMax: accrual_max
          accrualRate: accrual_rate
          carryoverLimit: carryover_limit
          depositPolicy: deposit_policy
          lumpDepositAmount: lump_deposit_amount
          percentPayout: percent_payout
          percentTerminationPayout: percent_termination_payout
          usageMax: usage_max
        }
      }
    }
  }
`;
